export const ACCESS_TOKEN = '_ata_token'
export const REFRESH_TOKEN = '_atr_token'
